




import { Component, Mixins, Prop } from "vue-property-decorator";
import { HisInformationDateTimeValue } from "../../../domain/his/HisInformationValue";
import { DateFormatter } from "../../../domain/system";

@Component({
})
export default class HisDateTimeItemComponent extends Mixins() {
  @Prop()
  source: HisInformationDateTimeValue;

  get formattedValue(): string {
    if (this.source == null) { return ""; }
    
    return this.source.data
      .map(x => DateFormatter.format(x, this.source.format))
      .join(",");
  }
}
